import FeedbackBadge from './FeedbackBadge';
import FeedbackThumbnail from './FeedbackThumbnail';

export { FeedbackBadge, FeedbackThumbnail };
